import { ActionType } from '../action-types';
import { ErrorAction } from '../types';

export function isErrorAction<T extends ActionType, E extends Error, M>(
  action: any,
): action is ErrorAction<T, M, E> {
  return action.error;
}
